import type { IconName } from '@/components/entities/Sprite/Icon';
import type { ModalNameType } from '@/modals/components/ModalProvider';
import { isFairPlayEnabled } from '@/app/[locale]/(root)/fair-play/availability';
import { AppRoutes } from '@/i18n/constants';

export type NavigationLink = {
  label: string;
  icon: IconName;
  href?: string;
  modal?: ModalNameType;
  badge?: string;
};

const FAIR_PLAY_LINK: NavigationLink = {
  label: 'Fair Play',
  icon: 'fairplay',
  href: `${AppRoutes.fairPlay}/dashboard`,
  badge: 'Beta',
};

export const PROTECTED_LINKS: NavigationLink[] = [
  {
    label: 'Purchases',
    icon: 'purchases',
    modal: 'deposit',
  },
  {
    label: 'Redeem',
    icon: 'redeem',
    modal: 'redeem',
  },
  {
    label: 'Promotions',
    modal: 'deposit',
    icon: 'promotion',
  },
  ...(isFairPlayEnabled() ? [FAIR_PLAY_LINK] : []),
];

export const ACCOUNT_LINKS: NavigationLink[] = [

  {
    label: 'Profile',
    href: '/profile',
    icon: 'profile',
  },

  {
    label: 'Customer Support',
    modal: 'support',
    icon: 'support-navbar',
  },
];
